var render, staticRenderFns
import script from "./ComptaPieChart.vue?vue&type=script&lang=js&"
export * from "./ComptaPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c5c286",
  null
  
)

export default component.exports